var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},[_c('b-card-actions',{ref:"formCard",attrs:{"title":"Ubah Profile","no-actions":"","no-body":""}},[_c('form-content',{on:{"on-submit":_vm.onSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }